module.exports = __webpack_public_path__ + "img/Grupo 331.2fa7f210.png";